import assert from 'minimalistic-assert';
import enforceObservableRules from '../enforce-rules.js';
import createSimpleObserver from '../simple-observer.js';
const getRange = (offset, length) => Array.from({ length }, (_, i) => i + offset);
const createSequencedKeystoreAtom = ({ keystore, config: { key, separator = '.', defaultValue = [], isSoleWriter, getOpts, setOpts, deleteOpts, }, }) => {
    assert(key, 'sequence keystore atom: key missing');
    assert(typeof key === 'string', 'sequence keystore atom: key must be a string');
    assert(Array.isArray(defaultValue), 'sequence keystore atom: default value must be an array');
    const { notify, observe } = createSimpleObserver({
        enable: isSoleWriter,
    });
    let cache;
    let isCachePopulated = false;
    const getKey = (index) => key.endsWith(separator) ? `${key}${index}` : `${key}${separator}${index}`;
    const getByIndex = async (index) => {
        const key = getKey(index);
        const value = await keystore.getSecret(key, getOpts);
        if (value)
            return { key, value };
    };
    const list = async () => {
        let result = [];
        let batch = [];
        let offset = 0;
        const batchSize = 5;
        do {
            const range = getRange(offset, batchSize);
            batch = await Promise.all(range.map(getByIndex));
            batch = batch.filter(Boolean);
            result = [...result, ...batch];
            offset += batchSize;
        } while (batch.length > 0);
        return result;
    };
    const clear = async () => {
        const items = await list();
        await Promise.all(items.map((item) => keystore.deleteSecret(item.key, deleteOpts)));
    };
    const _set = async (value) => {
        assert(Array.isArray(value), 'sequence keystore atom: set value must be an array');
        await Promise.all(value.map((value, index) => {
            return keystore.setSecret(getKey(index), value, setOpts);
        }));
    };
    const set = async (value) => {
        await clear();
        if (value !== undefined) {
            await _set(value);
        }
        if (isSoleWriter) {
            cache = value;
            isCachePopulated = true;
            await notify(value);
        }
    };
    const get = async () => {
        if (isCachePopulated)
            return cache;
        const items = await list();
        const value = items.length === 0 ? undefined : items.map((item) => item.value);
        if (isSoleWriter) {
            cache = value;
            isCachePopulated = true;
        }
        return value;
    };
    return enforceObservableRules({
        get,
        set,
        observe,
        defaultValue,
    });
};
export default createSequencedKeystoreAtom;
